import { Paper, Skeleton, Stack } from "@mui/material";

export const StoryCardSkeleton = () => (
  <Paper sx={{ borderRadius: 2, overflow: "hidden" }}>
    <Skeleton
      variant="rectangular"
      sx={{ aspectRatio: "3 / 4", height: "auto" }}
    />
    <Stack gap={0.5} p={1.5}>
      <Skeleton width="80%" />
      <Skeleton width="60%" />
      <Skeleton width="40%" />
    </Stack>
  </Paper>
);
